var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApparels(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "shirt-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22040_14640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22040_14640",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.882812 0.140629H34.8828V34.1406H0.882812V0.140629Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22040_14640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58594 23.9844C9.709 23.9844 9.78709 23.3975 10.9102 23.3975C12.0332 23.3975 12.1112 23.9844 13.2343 23.9844C14.3574 23.9844 14.4354 23.3975 15.5585 23.3975C15.7854 23.3975 15.9696 23.4214 16.1286 23.4597V13.4987C15.9696 13.4604 15.7854 13.4365 15.5585 13.4365C14.4354 13.4365 14.3574 14.0234 13.2343 14.0234C12.1112 14.0234 12.0332 13.4365 10.9102 13.4365C9.78709 13.4365 9.709 14.0234 8.58594 14.0234V23.9844Z",
    fill: "#E2C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6367 13.4987V23.4597C19.7956 23.4215 19.9798 23.3975 20.2068 23.3975C21.3299 23.3975 21.4079 23.9844 22.531 23.9844C23.654 23.9844 23.7321 23.3975 24.8551 23.3975C25.9782 23.3975 26.0563 23.9844 27.1793 23.9844V14.0234C26.0563 14.0234 25.9782 13.4365 24.8551 13.4365C23.7321 13.4365 23.654 14.0234 22.531 14.0234C21.4079 14.0234 21.3299 13.4365 20.2068 13.4365C19.9798 13.4365 19.7956 13.4604 19.6367 13.4987Z",
    fill: "#E2C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2082 17.9913L32.4921 14.6888C31.0443 11.5192 29.7544 8.69532 28.3065 5.52568C27.9511 4.74753 27.5863 4.38276 26.8204 3.99761L23.5125 2.8092M27.1795 12.6966V32.1563C27.1795 32.8868 26.5818 33.4844 25.8514 33.4844H19.6369V7.84087L21.495 0.993723M8.57617 18.003L3.27344 14.6888C4.72129 11.5192 6.01123 8.69532 7.45909 5.52568C7.81449 4.74753 8.17926 4.38276 8.94519 3.99761L12.2372 2.81491M16.0181 7.87315L12.1482 9.00178L12.3277 1.70075L14.2215 0.8125C15.3419 1.37357 16.6018 1.66801 17.8827 1.66801C19.1638 1.66801 20.4237 1.37357 21.5441 0.8125L23.438 1.70075L23.6175 9.00178L19.7025 7.86006M8.58607 12.6966V32.1563C8.58607 32.8868 9.18372 33.4844 9.91419 33.4844H16.1287V7.84087L14.2729 1.00216",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2402 31.4922H19.5243",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6738 16.8269C19.8311 16.7886 20.0135 16.7647 20.2382 16.7647C21.35 16.7647 21.4272 17.3516 22.5391 17.3516C23.651 17.3516 23.7282 16.7647 24.84 16.7647C25.9519 16.7647 26.0291 17.3516 27.1409 17.3516",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62305 17.3516C9.73482 17.3516 9.81212 16.7647 10.924 16.7647C12.0358 16.7647 12.1131 17.3516 13.2249 17.3516C14.3367 17.3516 14.414 16.7647 15.5258 16.7647C15.7505 16.7647 15.9329 16.7886 16.0902 16.8269",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6738 20.1472C19.8311 20.1089 20.0135 20.085 20.2382 20.085C21.35 20.085 21.4272 20.6719 22.5391 20.6719C23.651 20.6719 23.7282 20.085 24.84 20.085C25.9519 20.085 26.0291 20.6719 27.1409 20.6719",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62305 20.6719C9.73482 20.6719 9.81212 20.085 10.924 20.085C12.0358 20.085 12.1131 20.6719 13.2249 20.6719C14.3367 20.6719 14.414 20.085 15.5258 20.085C15.7505 20.085 15.9329 20.1089 16.0902 20.1472",
    stroke: "black",
    strokeWidth: 1.32812,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22040_14640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.882812 0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApparels);
export default __webpack_public_path__ + "static/media/Apparels.72eeec33e0eeac32fbabe6c7c2e09f9e.svg";
export { ForwardRef as ReactComponent };